import api from '@/api'

export default {
  async getOrganization (context, payload) {
    const organizationId = payload?.organizationId
    const response = await api.organization.getById(organizationId)

    return response
  },

  async updateOrganization (context, payload) {
    const response = await api.organization.update(
      payload.organizationId,
      payload.organization
    )

    return response
  },
}
